import React, { useCallback, useEffect } from 'react';
import { RewardsRail } from '@sweetgreen/garnish';

import { useChallengesAndRewards } from '@order/ChallengesAndRewards';
import { useLocalizationContext } from '@order/Localization';

import { useChallengesTelemetry } from '../../../../screens/ChallengesScreen/ChallengesScreen.telemetry';
import { BagRailContainer } from '../BagRailContainer';

// ────────────────────────────────────────────────────────────────────────────────

export const BagRewardsRail = () => {
  const { t } = useLocalizationContext();
  const {
    selectedRewardId,
    selectedRewardIndex,
    setSelectedRewardId,
    rewards,
    isFetchingRewards,
    rewardsError,
  } = useChallengesAndRewards();
  const { handleRewardSelectedTelemetry } = useChallengesTelemetry();

  const hasNoRewards =
    !isFetchingRewards && (!rewards || rewards?.length === 0);
  const hasError = Boolean(rewardsError);

  // ─────────────────────────────────────────────────────────────────

  const toggleReward = useCallback(
    (rewardId: string) => {
      setSelectedRewardId((currentlySelectedRewardId) =>
        currentlySelectedRewardId === rewardId ? '' : rewardId,
      );
    },
    [setSelectedRewardId],
  );

  // ─────────────────────────────────────────────────────────────────

  useEffect(() => {
    if (!selectedRewardId) return;
    handleRewardSelectedTelemetry(selectedRewardId);
  }, [selectedRewardId, handleRewardSelectedTelemetry]);

  // ─────────────────────────────────────────────────────────────────

  return (
    <BagRailContainer
      headerText={t('bag.rewards.header')}
      isEmpty={hasNoRewards}
      hasError={hasError}
    >
      <RewardsRail
        rewards={rewards}
        onPress={toggleReward}
        headerText={t('bag.rewards.header')}
        footerText={t('bag.rewards.footer')}
        deadlinePrefixText={t('bag.rewards.deadline-prefix')}
        selectedRewardId={selectedRewardId}
        isLoading={isFetchingRewards}
        initialScrollIndex={selectedRewardIndex}
      />
    </BagRailContainer>
  );
};
